import { useState, type MouseEvent } from "react";
import { Box, IconButton, Popover, Typography } from "@mui/material";
import { HelpOutline } from "@mui/icons-material";
import { WIZARD_STEP_HELP, type WizardStep } from "../../WizardContainer/WizardContainer.types";

// ============================================================================
// Types
// ============================================================================

export interface StepHelpButtonProps {
	step: WizardStep;
}

// ============================================================================
// Component
// ============================================================================

export function StepHelpButton({ step }: StepHelpButtonProps) {
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

	const help = WIZARD_STEP_HELP[step];
	const isOpen = Boolean(anchorEl);

	return (
		<>
			<IconButton
				size="small"
				aria-label="Step help"
				onClick={(e: MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget)}
				sx={{ color: "action.active" }}
			>
				<HelpOutline fontSize="small" />
			</IconButton>
			<Popover
				open={isOpen}
				anchorEl={anchorEl}
				onClose={() => setAnchorEl(null)}
				anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
				transformOrigin={{ vertical: "top", horizontal: "left" }}
			>
				<Box sx={{ maxWidth: 360, p: 2 }}>
					<Typography variant="body2" sx={{ mb: help.actions ? 1 : 0 }}>
						{help.summary}
					</Typography>
					{help.actions && (
						<Box component="ul" sx={{ m: 0, pl: 2.5 }}>
							{help.actions.map((action) => (
								<Typography key={action} component="li" variant="body2" color="text.secondary">
									{action}
								</Typography>
							))}
						</Box>
					)}
				</Box>
			</Popover>
		</>
	);
}
